import { getCookie, setCookie } from "@/shared/lib/cookies"

export interface FacebookClickIds {
  fbc: string | null
  fbp: string | null
}

/**
 * Resolve Facebook's `_fbc` / `_fbp` identifiers used for CAPI deduplication.
 *
 * - `_fbc` is derived from the `fbclid` URL param (or an existing cookie).
 * - `_fbp` is read from the cookie or generated and persisted so it stays
 *   stable for the visitor.
 *
 * Mirrors the Meta Pixel cookie format: `fb.1.<timestamp>.<value>`.
 */
export function getFacebookClickIds(): FacebookClickIds {
  if (typeof window === "undefined") return { fbc: null, fbp: null }

  try {
    const now = Date.now()
    const fbclid = new URLSearchParams(window.location.search).get("fbclid")

    let fbc = getCookie("_fbc")
    if (!fbc && fbclid) {
      fbc = `fb.1.${now}.${fbclid}`
      setCookie("_fbc", fbc)
    }

    let fbp = getCookie("_fbp")
    if (!fbp) {
      fbp = `fb.1.${now}.${Math.random().toString().slice(2, 12)}`
      setCookie("_fbp", fbp)
    }

    return { fbc: fbc ?? null, fbp }
  } catch {
    return { fbc: null, fbp: null }
  }
}
